export default __webpack_public_path__ + "static/media/trash.aa2eec99.svg";